document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__accordion .title-box').forEach(function (titleBox) {
    var accordion = titleBox.closest('.product__accordion');
    var content = accordion.querySelector('.accordion__content');
    
    // 默认全部隐藏
    content.style.display = 'none';
    
    titleBox.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        content.style.display = 'none';
        accordion.classList.remove('is-open');
      } else {
        content.style.display = 'block';
        accordion.classList.add('is-open');
      }
    });
  });
});
